const defaultBreakpoints = {
  xs: 320,
  sm: 650,
  md: 950,
  lg: 1280,
  xl: 1920
}

const getActiveBreakpoint = breakpoints => wdt => {
  // coerce to number
  const width = (wdt *= 1)

  if (isNaN(width)) {
    return null
  }

  if (width <= breakpoints.xs) {
    return 'xs'
  }

  const sortedKeys = Object.keys(breakpoints).sort((a, b) => breakpoints[a] - breakpoints[b])
  const upperBoundIdx = sortedKeys.findIndex(key => breakpoints[key] > width)

  return upperBoundIdx > -1 ? sortedKeys[upperBoundIdx - 1] : sortedKeys[sortedKeys.length - 1]
}

const getResponsiveProps = (breakpoints = defaultBreakpoints) => ({
  breakpoints,
  getActiveBreakpoint: getActiveBreakpoint(breakpoints)
})

export default getResponsiveProps
